import { useAdsContext } from "@/context/AdsContext";
import { IMicrosite, IMicrositeStyle } from "@/types/microsite";
import { assetPrefix } from "@/vars/assetUrl";
import homeUrl from "@/vars/homeUrl";
import { micrositeVendorsConfig } from "@/vars/vendors";
import { cn } from "@/lib/utils";
import { Fragment, useMemo, useState } from "react";

interface Props {
  style?: IMicrositeStyle;
  isBuilder?: boolean;
  data?: IMicrosite;
}

export const MicrositeFooter = ({ isBuilder, style: _style, data }: Props) => {
  const { placement } = useAdsContext();

  const [footerShow, setFooterShow] = useState(true);

  const style = useMemo(() => {
    const style = { ..._style };
    if (data?.extras?.vendor) {
      const vendor = micrositeVendorsConfig[data.extras.vendor];
      if (vendor && vendor?.micrositeFooter) {
        style.collaborationImage = vendor.micrositeFooter.image;
        style.collaborationImageWidth = vendor.micrositeFooter.width;
        style.collaborationBaseColor = vendor.micrositeFooter.baseColor;
      }
    }

    return style;
  }, [_style, data?.extras]);

  return (
    <div className="flex flex-col items-center mt-10 w-full font-worksans">
      {style?.collaborationImage ? (
        <div
          className={cn("relative -mt-10 w-full h-40 pointer-events-none")}
          style={{
            paddingBottom: placement?.microsite_sid_sticky?.enabled
              ? "18rem"
              : undefined,
          }}
        >
          <div
            className={cn(
              "top-0 -right-[50vw] -left-[50vw] absolute bg-gradient-to-b h-full",
              style.collaborationBaseColor === "light"
                ? "from-[#FFFFFF00] to-[#FFFFFFb6]"
                : "from-[#00000000] to-[#000000b6]"
            )}
          />
          <div className="z-20 absolute inset-0 flex justify-center items-center">
            <a
              href={
                homeUrl + "?utm_source=sid-microsite&utm_medium=" + data?.slug
              }
              target="_blank"
              className="cursor-pointer pointer-events-auto"
              rel="noopener noreferrer"
              onClick={(e) => {
                if (isBuilder) {
                  e.preventDefault();
                }
              }}
            >
              <img
                src={"//cdn.s.id/assets/" + style.collaborationImage}
                alt="collaboration logo"
                style={{
                  maxWidth:
                    //@ts-ignore
                    style?.collaborationImageWidth > 0
                      ? style?.collaborationImageWidth
                      : undefined,
                }}
              />
            </a>
          </div>
        </div>
      ) : (
        <Fragment>
          <div
            style={{
              paddingBottom: placement?.microsite_sid_sticky?.enabled
                ? "6rem"
                : undefined,
            }}
          >
            <div
              className={cn(
                "z-10 bg-white shadow-lg mb-10 px-4 py-1.5 rounded-full transition-all hover:-translate-y-1",
                footerShow ? "block" : "hidden"
              )}
            >
              <div className="z-10 relative flex justify-center items-center w-full font-medium text-sm text-center">
                <p className="text-gray-700">Powered by</p>
                <img
                  src={`${assetPrefix}images/sid-neu-logo-dark.svg`}
                  className="mr-0.5 ml-2 h-7"
                  alt="s.id logo"
                />
                <a
                  href={
                    homeUrl +
                    "?utm_source=sid-microsite&utm_medium=" +
                    data?.slug
                  }
                  target="_blank"
                  rel="noopener noreferrer pointer-events-auto cursor-pointer"
                  className="top-0 left-0 absolute w-full h-full"
                  onClick={(e) => {
                    if (isBuilder) {
                      e.preventDefault();
                    }
                  }}
                >
                  <span className="link" />
                </a>
              </div>
            </div>
          </div>
          <AskToJoinSIDComponent
            show={footerShow}
            data={data}
            isBuilder={isBuilder}
            onToggle={() => setFooterShow(true)}
          />
        </Fragment>
      )}
    </div>
  );
};

const AskToJoinSIDComponent = ({ show, onToggle, data, isBuilder }) => {
  return (
    <div
      className={cn(
        "right-0 bottom-[--microsite-sticky-bottom] left-0 z-20 fixed pointer-events-none",
        show ? "hidden" : "block"
      )}
    >
      <style>{`.__sticky-open { --microsite-sticky-bottom: 60px} .__sticky-close { --microsite-sticky-bottom: 0px}`}</style>
      <div className="top-0 right-0 bottom-0 left-0 absolute overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent translate-y-5"></div>
      </div>
      <div className="z-20 relative flex flex-col items-center mx-auto p-3 pb-10 max-w-[--max-container-width] text-center pointer-events-auto">
        <a
          href={homeUrl + "?utm_source=sid-microsite&utm_medium=" + data?.slug}
          target="_blank"
          rel="noopener noreferrer pointer-events-auto cursor-pointer"
          className="flex items-center bg-white shadow-xl px-4 py-2 rounded-full text-gray-800 text-sm"
          onClick={(e) => {
            if (isBuilder) {
              e.preventDefault();
            }
          }}
        >
          <img
            src={`${assetPrefix}images/sid-neu-logo-single.svg`}
            className="mr-2 h-4"
            alt="s.id logo"
          />
          s.id/yourname
        </a>
        <p className="mt-3 text-white text-sm">Create your first Microsite</p>
        <p className="text-white text-sm">
          <a
            href="#"
            className="underline"
            onClick={(e) => {
              e.preventDefault();
              onToggle();
            }}
          >
            Close
          </a>
        </p>
      </div>
    </div>
  );
};
